import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as LiliLogo } from '../../../../../assets/icons/svg/icon-new-lili-logo-white.svg';

export const VendorDetailsRequestIntroHeader = () => {
  const { t } = useTranslation();

  return (
    <div className='w-full flex-flex-col items-center'>
      <div className=' flex flex-col  items-center bg-action03 pb-[43px] pt-[53px] '>
        <LiliLogo className='w-[66px] h-[40px]' />
        <p className='mt-[53px] font-metricRSemibold text-[24px] text-bw01'>{t('ASK_VENDOR.INTRO.WELCOME_TITLE')}</p>
        <p className='font-metricR text-[18px] text-bw01'>{t('ASK_VENDOR.INTRO.WELCOME_SUBTITLE')}</p>
      </div>
    </div>
  );
};
